import type { GetServerSideProps, NextPage } from 'next';
import { Frontpage } from '@/components/FrontPage';
import { verticalConfig } from '@/config/verticalConfig';
import { createSspForVertical, type SspProps } from '@/util/verticalSsp';

const FrontPageFlight: NextPage<SspProps> = (pageProps) => <Frontpage config={verticalConfig.flight} {...pageProps} />;

// @ts-ignore prop mismatch because we add 'locals' to NextPageResponse
export const getServerSideProps: GetServerSideProps<SspProps> = createSspForVertical(verticalConfig.flight.vertical);

export default FrontPageFlight;
